import React from "react";
import { cn } from "@/lib/utils";
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

interface AppHeaderProps {
  title?: string;
  className?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  onLeftIconClick?: () => void;
  onRightIconClick?: () => void;
  showBackButton?: boolean;
}

const AppHeader: React.FC<AppHeaderProps> = ({
  title = "ŞantiyeX",
  className,
  leftIcon,
  rightIcon,
  onLeftIconClick,
  onRightIconClick,
  showBackButton = false,
}) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <header 
      data-header
      data-safe-top-header
      className={cn(
        "fixed top-0 left-0 right-0 h-[var(--header-safe-height)] flex items-center justify-between px-4 z-[990] border-b border-gray-200 bg-white text-gray-900",
        className
      )}
    >
      {showBackButton ? (
        <button
          className="p-2 -ml-2"
          onClick={handleBackClick}
        >
          <ChevronLeft className="h-6 w-6" />
        </button>
      ) : leftIcon ? (
        <button 
          className="p-2 -ml-2"
          onClick={onLeftIconClick}
        >
          {leftIcon}
        </button>
      ) : (
        <div className="w-8"></div> 
      )}
      
      <h1 className="text-lg font-semibold text-gray-900 text-center">{title}</h1>
      
      {rightIcon ? (
        <button 
          className="p-2 -mr-2"
          onClick={onRightIconClick}
        >
          {rightIcon}
        </button>
      ) : (
        <div className="w-8"></div>
      )}
    </header>
  );
};

export default AppHeader;
